import { useState } from 'react'

import * as Styled from './styled'

import { t } from 'i18next'
import { shareLink } from 'utils/share'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { Typography } from '@mui/material'
import { MiscText } from 'components/login/styled'
import { theme } from 'theme'

export interface InviteLinkBadgeProps {
  link: string
}

export default function InviteLinkBadge(props: InviteLinkBadgeProps) {
  if (!props.link) {
    return <></>
  }

  return (
    <Styled.InviteLinkBadge padding={3} gap={2}>
      <PopupSectionRow
        title={
          <Typography
            fontFamily={'NotoSans'}
            fontSize={'18px'}
            fontWeight={500}
          >
            {t('inviteOthersToJoin')}
          </Typography>
        }
        value=""
      />
      <MiscText
        mt={-2}
        fontSize={'14px'}
        fontWeight={'400 !important'}
        color={theme.palette.text.secondary}
      >
        {t('anyoneWithThisLink')}
      </MiscText>
      <InviteLinkRow width="90% !important" link={props.link} />
    </Styled.InviteLinkBadge>
  )
}

interface InviteLinkRowProps {
  link: string
  text?: string
  textSize?: string
  allowScroll?: boolean
  width?: string
  height?: string
}

export function InviteLinkRow(props: InviteLinkRowProps) {
  const [linkCopyTitle, setLinkCopyTitle] = useState<string>(
    `${t('copyToClipboard')}`
  )

  async function handleCopyAction() {
    try {
      setLinkCopyTitle(`${t('copied')}`)
      await navigator.clipboard.writeText(props.text ?? props.link)
      shareLink(props.text ?? props.link)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Styled.InviteLinkContainer
      height={props.height ?? '30px'}
      width={props.width}
      container
      dir="ltr"
      mt={2}
    >
      <Styled.LinkContent
        id="invite-link"
        style={{
          fontSize: props.textSize ? props.textSize : '14px',
          textAlign: 'start'
        }}
        {...props}
      >
        {props.text ?? props.link}
      </Styled.LinkContent>
      <Styled.CopyLinkButton onClick={handleCopyAction}>
        {linkCopyTitle}
      </Styled.CopyLinkButton>
    </Styled.InviteLinkContainer>
  )
}
